module.exports = __webpack_public_path__ + "img/生成系统.f35dddc3.png";